import { CategoryId, QuickSearchCategories } from '~/models/category/types'

export const quickSearchCategories: QuickSearchCategories = Object.freeze({
  vehicles: {
    name: 'vehicles',
    nameTranslationKey: 'vehicles',
    id: CategoryId.VEHICLES,
    link: {
      name: '__classifieds_quick_search',
      params: { root: 'vehicles', category: 'cars' }
    },
    children: [
      {
        name: 'cars',
        nameTranslationKey: 'cars',
        id: CategoryId.CARS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'vehicles', category: 'cars' }
        },
        facets: [
          {
            name: 'makemodel',
            showModel: true,
            showTopMakesButtons: true,
            showMakesLogos: true,
            makesLogosType: 'cars'
          },
          { name: 'registration' },
          { name: 'mileage' },
          { name: 'price', isFullWidthOnMobile: true },
          { name: 'category' },
          { name: 'fuel_type' },
          {
            name: 'offer_type',
            type: 'OfferTypeCarsFrontEndSearchHandler'
          }
        ]
      },
      {
        name: 'bikes',
        nameTranslationKey: 'bikes',
        id: CategoryId.BIKES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'vehicles', category: 'bikes' }
        },
        facets: [
          {
            name: 'makemodel',
            showModel: true,
            showTopMakesButtons: true,
            showMakesLogos: true,
            makesLogosType: 'bikes'
          },
          { name: 'registration' },
          { name: 'mileage' },
          { name: 'price', isFullWidthOnMobile: true },
          { name: 'category' },
          { name: 'location2' }
        ]
      },
      {
        name: 'commercials',
        nameTranslationKey: 'commercials',
        id: CategoryId.COMMERCIAL,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'vehicles', category: 'commercials' }
        },
        children: [
          {
            name: 'vans',
            nameTranslationKey: 'vans',
            id: CategoryId.VANS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'vans'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category' },
              { name: 'registration' },
              { name: 'mileage', isFullWidthOnMobile: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'euroclass', isFullWidthOnMobile: true },
              { name: 'weight', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'trucks',
            nameTranslationKey: 'trucks',
            id: CategoryId.TRUCKS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'trucks'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category', isFullWidthOnMobile: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'mileage', isFullWidthOnMobile: true },
              { name: 'axles', isFullWidthOnMobile: true },
              { name: 'euroclass', isFullWidthOnMobile: true },
              { name: 'weight', isFullWidthOnMobile: true },
              { name: 'payload', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'tractors',
            nameTranslationKey: 'tractors',
            id: CategoryId.TRACTORS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'tractors'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category' },
              { name: 'registration' },
              { name: 'mileage', isFullWidthOnMobile: true, showFrom: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'engine_power', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'builders',
            nameTranslationKey: 'builders',
            id: CategoryId.BUILDERS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'builders'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category' },
              { name: 'registration' },
              { name: 'mileage', isFullWidthOnMobile: true, showFrom: true },
              { name: 'price', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'semitrucks',
            nameTranslationKey: 'semitrucks',
            id: CategoryId.SEMITRUCKS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'semitrucks'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category', isFullWidthOnMobile: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'mileage' },
              { name: 'registration' },
              { name: 'euroclass', isFullWidthOnMobile: true },
              { name: 'weight', isFullWidthOnMobile: true },
              { name: 'axles', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'semitrailers',
            nameTranslationKey: 'semitrailers',
            id: CategoryId.SEMITRAILERS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'semitrailers'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category', isFullWidthOnMobile: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'registration', isFullWidthOnMobile: true },
              { name: 'weight', isFullWidthOnMobile: true },
              { name: 'mileage', isFullWidthOnMobile: true },
              { name: 'payload', isFullWidthOnMobile: true },
              { name: 'axles', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'buses',
            nameTranslationKey: 'buses',
            id: CategoryId.BUSES,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'buses'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category', isFullWidthOnMobile: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'registration', isFullWidthOnMobile: true },
              { name: 'seats', isFullWidthOnMobile: true },
              { name: 'mileage', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'forklifts',
            nameTranslationKey: 'forklifts',
            id: CategoryId.FORKLIFTS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'forklifts'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category' },
              { name: 'registration' },
              { name: 'fuel_type', isFullWidthOnMobile: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'maximum_lift_height', isFullWidthOnMobile: true },
              { name: 'maximum_capacity', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'trailers',
            nameTranslationKey: 'trailers',
            id: CategoryId.TRAILERS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'trailers'
              }
            },
            facets: [
              { name: 'makemodel', showVariant: true },
              { name: 'category', isFullWidthOnMobile: true },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'length', isFullWidthOnMobile: true },
              { name: 'weight', isFullWidthOnMobile: true },
              { name: 'payload', isFullWidthOnMobile: true },
              { name: 'axles', isFullWidthOnMobile: true }
            ]
          },
          {
            name: 'taxis',
            nameTranslationKey: 'taxis',
            id: CategoryId.TAXIS,
            link: {
              name: '__classifieds_quick_search',
              params: {
                root: 'vehicles',
                category: 'commercials',
                subCategory: 'taxis'
              }
            },
            facets: [
              { name: 'makemodel', showModel: true },
              { name: 'registration' },
              { name: 'mileage' },
              { name: 'price', isFullWidthOnMobile: true },
              { name: 'fuel_type' },
              { name: 'category' }
            ]
          }
        ]
      },
      {
        name: 'campers',
        nameTranslationKey: 'campers',
        id: CategoryId.CAMPERS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'vehicles', category: 'campers' }
        },
        children: [
          {
            name: 'caravans',
            nameTranslationKey: 'caravans',
            id: CategoryId.CARAVANS,
            link: {
              path: `/caravans/?category=15421&category=15435&category=15439&category=15766&category=15830&category=15872`
            }
          },
          {
            name: 'motorhomes',
            nameTranslationKey: 'motorhomes',
            id: CategoryId.MOTORHOMES,
            link: {
              path: '/motorhomes'
            }
          },
          {
            name: 'caravanhouses',
            nameTranslationKey: 'caravanhouses',
            id: CategoryId.CARAVANHOUSE,
            link: {
              path: `/caravans/?category=${CategoryId.CARAVANHOUSE}`
            }
          },
          {
            name: 'container',
            nameTranslationKey: 'container',
            id: CategoryId.CONTAINER,
            link: {
              path: `/caravans/?category=${CategoryId.CONTAINER}`
            }
          }
        ]
      },
      {
        name: 'bicycles',
        nameTranslationKey: 'bicycles',
        id: CategoryId.BICYCLES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'vehicles', category: 'bicycles' }
        },
        facets: [
          { name: 'category' },
          { name: 'makemodel' },
          { name: 'price' },
          { name: 'location2' },
          { name: 'rim_size' }
        ]
      },
      {
        name: 'hobby',
        nameTranslationKey: 'hobby',
        id: CategoryId.HOBBY,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'vehicles', category: 'hobby' }
        },
        children: [
          {
            name: 'bicycles',
            nameTranslationKey: 'bicycles',
            id: CategoryId.BICYCLES,
            link: {
              path: '/bicycles'
            }
          },
          {
            name: 'watersports',
            nameTranslationKey: 'watersports',
            id: CategoryId.WATERSPORTS,
            link: {
              path: '/watersports'
            }
          },
          {
            name: 'radiocontrols',
            nameTranslationKey: 'radiocontrols',
            id: CategoryId.RADIOCONTROLS,
            link: {
              path: '/radiocontrols'
            }
          },
          {
            name: 'snowsports',
            nameTranslationKey: 'snowsports',
            id: CategoryId.SNOWSPORTS,
            link: {
              path: '/snowsports'
            }
          },
          {
            name: 'gokarts',
            nameTranslationKey: 'gokarts',
            id: CategoryId.GOKARTS,
            link: {
              path: '/gokarts'
            }
          },
          {
            name: 'airsports',
            nameTranslationKey: 'airsports',
            id: CategoryId.AIRSPORTS,
            link: {
              path: '/airsports'
            }
          }
        ]
      }
    ]
  },
  boats: {
    name: 'boats',
    nameTranslationKey: 'boats',
    id: CategoryId.BOATS,
    link: {
      name: '__classifieds_quick_search',
      params: { root: 'boats' }
    },
    facets: [
      {
        name: 'category',
        type: 'FrontEndCategoryGridIconsHandler'
      }
    ]
  },
  parts: {
    name: 'parts',
    nameTranslationKey: 'parts_and_accessories',
    id: CategoryId.PARTS,
    link: {
      name: '__classifieds_quick_search',
      params: { root: 'parts', category: 'for-cars' }
    },
    children: [
      {
        name: 'for-cars',
        nameTranslationKey: 'for-cars',
        id: CategoryId.PARTS_CARS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-cars' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-bikes',
        nameTranslationKey: 'for-bikes-rider',
        id: CategoryId.PARTS_BIKES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-bikes' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-boats',
        nameTranslationKey: 'for-boats',
        id: CategoryId.PARTS_BOATS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-boats' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-trucks',
        nameTranslationKey: 'for-trucks',
        id: CategoryId.PARTS_TRUCKS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-trucks' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-tractors',
        nameTranslationKey: 'for-tractors',
        id: CategoryId.PARTS_TRACTORS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-tractors' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-buses',
        nameTranslationKey: 'for-buses',
        id: CategoryId.PARTS_BUSES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-buses' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-builders',
        nameTranslationKey: 'for-builders',
        id: CategoryId.PARTS_BUILDERS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-builders' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-forklifts',
        nameTranslationKey: 'for-forklifts',
        id: CategoryId.PARTS_FORKLIFTS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-forklifts' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-tools',
        nameTranslationKey: 'for-tools',
        id: CategoryId.PARTS_TOOLS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-tools' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-motorhomes',
        nameTranslationKey: 'for-motorhomes',
        id: CategoryId.PARTS_CAMPERS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-motorhomes' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      },
      {
        name: 'for-bicycles',
        nameTranslationKey: 'for-bicycles',
        id: CategoryId.PARTS_BICYCLES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'parts', category: 'for-bicycles' }
        },
        facets: [
          { name: 'mein', isParts: true },
          {
            name: 'category',
            type: 'FrontEndCategoryGridHandler',
            isParts: true
          }
        ]
      }
    ]
  },
  rentals: {
    name: 'rentals',
    nameTranslationKey: 'rentals',
    id: CategoryId.RENTALS,
    link: {
      name: '__classifieds_quick_search',
      params: { root: 'rentals', category: 'cars' }
    },
    children: [
      {
        name: 'cars',
        nameTranslationKey: 'cars',
        id: CategoryId.RENTALS_CARS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'cars' }
        },
        facets: [
          { name: 'pickup_location' },
          { name: 'rental_period', isFullWidthOnMobile: true },
          {
            name: 'category',
            isFullWidthOnMobile: true,
            showSelectedCategoryChildrenOnly: true
          },
          { name: 'doors', isFullWidthOnMobile: true },
          { name: 'extra_services', isFullWidthOnMobile: true }
        ]
      },
      {
        name: 'bikes',
        nameTranslationKey: 'bikes',
        id: CategoryId.RENTALS_BIKES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'bikes' }
        },
        facets: [
          { name: 'pickup_location' },
          { name: 'rental_period' },
          { name: 'category', showSelectedCategoryChildrenOnly: true },
          { name: 'gearbox_type' },
          { name: 'extra_services' }
        ]
      },
      {
        name: 'boats',
        nameTranslationKey: 'boats',
        id: CategoryId.RENTALS_BOATS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'boats' }
        },
        facets: [
          { name: 'pickup_location' },
          { name: 'rental_period' },
          { name: 'category', showSelectedCategoryChildrenOnly: true },
          { name: 'length' },
          { name: 'passengers' }
        ]
      },
      {
        name: 'commercials',
        nameTranslationKey: 'commercials',
        id: CategoryId.RENTALS_COMMERCIALS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'commercials' }
        },
        facets: [
          { name: 'pickup_location' },
          { name: 'rental_period' },
          { name: 'category', showSelectedCategoryChildrenOnly: true },
          { name: 'fuel_type' },
          { name: 'extra_services' }
        ]
      },
      {
        name: 'campers',
        nameTranslationKey: 'campers',
        id: CategoryId.RENTALS_CAMPERS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'campers' }
        },
        facets: [
          { name: 'pickup_location' },
          { name: 'rental_period' },
          { name: 'category', showSelectedCategoryChildrenOnly: true },
          { name: 'length' },
          { name: 'beds' }
        ]
      },
      {
        name: 'bicycles',
        nameTranslationKey: 'bicycles',
        id: CategoryId.RENTALS_BICYCLES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'bicycles' }
        },
        facets: [
          { name: 'pickup_location', classes: 'md:tw-col-span-1' },
          { name: 'rental_period' }
        ]
      },
      {
        name: 'hobby',
        nameTranslationKey: 'hobby',
        id: CategoryId.RENTALS_HOBBY,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'hobby' }
        },
        facets: [
          { name: 'pickup_location', classes: 'md:tw-col-span-1' },
          { name: 'rental_period' }
        ]
      },
      {
        name: 'misc',
        nameTranslationKey: 'misc',
        id: CategoryId.RENTALS_MISC,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'rentals', category: 'misc' }
        },
        facets: [
          { name: 'pickup_location', classes: 'md:tw-col-span-1' },
          { name: 'rental_period' },
          { name: 'category', showSelectedCategoryChildrenOnly: true }
        ]
      }
    ]
  },
  xyma: {
    name: 'xyma',
    nameTranslationKey: 'xyma',
    id: CategoryId.XYMA,
    link: {
      name: '__classifieds_quick_search',
      params: { root: 'xyma', category: 'technology-security' }
    },
    children: [
      {
        name: 'technology-security',
        nameTranslationKey: 'technology-security',
        id: CategoryId.XYMA_TECHNOLOGY_SECURITY,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'technology-security' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'house-garden',
        nameTranslationKey: 'house-garden',
        id: CategoryId.XYMA_HOUSE_GARDEN,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'house-garden' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'tools-accessories',
        nameTranslationKey: 'tools-accessories',
        id: CategoryId.XYMA_TOOLS_ACCESSORIES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'tools-accessories' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'catering-equipment',
        nameTranslationKey: 'catering-equipment',
        id: CategoryId.XYMA_CATERING_EQUIPMENT,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'catering-equipment' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'business-equipment',
        nameTranslationKey: 'business-equipment',
        id: CategoryId.XYMA_BUSINESS_EQUIPMENT,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'business-equipment' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'antiques',
        nameTranslationKey: 'antiques',
        id: CategoryId.XYMA_ANTIQUES,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'antiques' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'hobby-sports',
        nameTranslationKey: 'hobby-sports',
        id: CategoryId.XYMA_HOBBY_SPORTS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'hobby-sports' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'fashion',
        nameTranslationKey: 'fashion',
        id: CategoryId.XYMA_FASHION,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'fashion' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'health-beauty-medicine',
        nameTranslationKey: 'health-beauty-medicine',
        id: CategoryId.XYMA_HEALTH_BEAUTY_MEDICINE,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'health-beauty-medicine' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'children-goods',
        nameTranslationKey: 'children-goods',
        id: CategoryId.XYMA_CHILDREN_GOODS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'children-goods' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'pets',
        nameTranslationKey: 'pets',
        id: CategoryId.XYMA_PETS,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'pets' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      },
      {
        name: 'supermarket',
        nameTranslationKey: 'supermarket',
        id: CategoryId.XYMA_SUPERMARKET,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'xyma', category: 'supermarket' }
        },
        facets: [
          { name: 'mein' },
          { name: 'category', type: 'FrontEndCategoryGridHandler' }
        ]
      }
    ]
  },
  plot: {
    name: 'plot',
    nameTranslationKey: 'plot',
    id: CategoryId.PLOT,
    link: {
      name: '__classifieds_quick_search',
      params: { root: 'plot', category: 'sale' }
    },
    children: [
      {
        name: 'sale',
        nameTranslationKey: 'sale',
        id: CategoryId.PLOT_SALE,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'plot', category: 'sale' }
        },
        facets: [
          { name: 'location', showLabel: true, classes: 'tw-col-span-full' },
          {
            name: 'category',
            isFullWidthOnMobile: true,
            showSelectedCategoryChildrenOnly: true
          },
          { name: 'area', isFullWidthOnMobile: true },
          { name: 'price', isFullWidthOnMobile: true },
          { name: 'price_per_square_meter', isFullWidthOnMobile: true }
        ]
      },
      {
        name: 'rent',
        nameTranslationKey: 'rent',
        id: CategoryId.PLOT_RENT,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'plot', category: 'rent' }
        },
        facets: [
          { name: 'location', showLabel: true, classes: 'tw-col-span-full' },
          { name: 'category', showSelectedCategoryChildrenOnly: true },
          { name: 'area' },
          { name: 'price' },
          { name: 'price_per_square_meter' }
        ]
      },
      {
        name: 'booking',
        nameTranslationKey: 'booking',
        id: CategoryId.PLOT_BOOKING,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'plot', category: 'booking' }
        },
        facets: [
          { name: 'location', showLabel: true, classes: 'tw-col-span-full' },
          { name: 'category', showSelectedCategoryChildrenOnly: true },
          { name: 'price' },
          { name: 'bedrooms' },
          { name: 'specials' }
        ]
      },
      {
        name: 'wanted-property',
        nameTranslationKey: 'wanted-property',
        id: CategoryId.PLOT_WANTED_PROPERTY,
        link: {
          name: '__classifieds_quick_search',
          params: { root: 'plot', category: 'wanted-property' }
        },
        facets: [
          { name: 'location', showLabel: true, classes: 'tw-col-span-full' },
          { name: 'category', showSelectedCategoryChildrenOnly: true },
          { name: 'area' },
          { name: 'price' },
          { name: 'price_per_square_meter' }
        ]
      }
    ]
  },
  jobs: {
    name: 'jobs',
    nameTranslationKey: 'jobs',
    id: CategoryId.JOBS,
    link: {
      name: '__classifieds_search_jobs'
    }
  },
  deals: {
    name: 'deals',
    nameTranslationKey: 'deals',
    id: CategoryId.DEALS,
    link: {
      name: '__classifieds_search_deals'
    }
  },
  'wanted-parts': {
    name: 'wanted_parts',
    nameTranslationKey: 'wanted_parts',
    id: CategoryId.WANTED_PARTS,
    link: {
      name: '__classifieds_search_wanted_parts'
    }
  }
})
